interface PhlebotomyLocationPhone {
  /** Ten-digit NANP number, digits only */
  number: string;
  /** Optional extension, digits only */
  extension?: string;
}

export type PhlebotomyFinderSiteType =
  | "brick_and_mortar"
  | "bto_psc"
  | "mobile_phlebotomy";

export type PhlebotomyFinderActionType =
  | "call"
  | "text"
  | "email"
  | "website"
  | "directions"
  | "schedule_mobile_draw";

export interface PhlebotomyFinderAction {
  type: PhlebotomyFinderActionType;
  target: string;
  isPrimary: boolean;
}

export interface PhlebotomyLocation {
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  phone?: PhlebotomyLocationPhone;
  coordinates: {
    lat: number;
    lng: number;
  } | null;
  metadata?: string[];
  siteNotes?: string[];
  schedulingUrl?: string;
  distanceMiles?: number;
  siteType?: PhlebotomyFinderSiteType;
  isPreferred?: boolean;
  finderActions?: PhlebotomyFinderAction[];
}

export interface MobilePhlebotomyLink {
  name: string;
  link: string;
  notes: string[];
}

export interface MobilePhlebotomyPhoneNumber extends PhlebotomyLocationPhone {
  name: string;
  callToBook: boolean;
  textToBook: boolean;
  notes: string[];
}

/**
 * Formats a 10-digit phone number as (XXX) XXX-XXXX.
 * If an extension is present, appends "ext. {extension}".
 */
export const formatPhoneDisplay = (phone: PhlebotomyLocationPhone): string => {
  const { number, extension } = phone;
  const formatted = `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6, 10)}`;
  return extension ? `${formatted} ext. ${extension}` : formatted;
};

export const formatPhoneForTel = (phone: PhlebotomyLocationPhone): string => {
  let telUri = `tel:${phone.number}`;
  if (phone.extension) {
    telUri += `;ext=${phone.extension}`;
  }
  return telUri;
};
